import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import moment from "moment"

const formatDate = d => d ? moment(d).format("DD/MM/YYYY") : ""

const RecorrenciaInfoBanner = props => {
  const { t, recorrencia } = props
  if (!recorrencia) return null

  const freqMap = { S: "semanal", Q: "quinzenal", M: "mensal", B: "bimestral", T: "trimestral", E: "semestral", A: "anual" }
  const frequencia = t(`contaspagar.recorrencia.frequencia.${ freqMap[recorrencia.frequencia] || "mensal" }`)
  const inicio = formatDate(recorrencia.data_inicio)

  let terminoLabel = ""
  if (recorrencia.data_fim) terminoLabel = t("contaspagar.recorrencia.banner.termino_data", { data: formatDate(recorrencia.data_fim) })
  else if (recorrencia.qtd_recorrencias) terminoLabel = t("contaspagar.recorrencia.banner.termino_qtd", { qtd: recorrencia.qtd_recorrencias })

  return (
    <div className="alert alert-info d-flex align-items-start" role="alert">
      <i className="mdi mdi-repeat font-size-20 me-2" />
      <div>
        <strong>{ t("contaspagar.recorrencia.banner.titulo") }</strong>
        <div>{ t("contaspagar.recorrencia.banner.detalhe", { frequencia, inicio, terminoLabel }) }</div>
        <small className="text-muted">{ t("contaspagar.recorrencia.banner.alterar_regra") }</small>
      </div>
    </div>
  )
}

RecorrenciaInfoBanner.propTypes = {
  recorrencia: PropTypes.object,
}

export default withTranslation()(RecorrenciaInfoBanner)
